export const getFormattedNumber = (value: number): number | string => {
  if (value >= 1000) {
    return `${Math.round(Math.abs(value) / 100) / 10}k`;
  }

  return value;
};
